module.exports = require('./lib/_stream_duplex.js');



//////////////////
// WEBPACK FOOTER
// /root/anvel/~/readable-stream/duplex-browser.js
// module id = ../../../../readable-stream/duplex-browser.js
// module chunks = 4